
import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef, Signal, viewChild } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { FormsModule, NgForm, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { AlertComponent } from '@libs/common/components';
import { SubmitGroupComponent, TextComponent } from '@libs/form/components';
import { SubmitGroupItemModel, TextInputModel } from '@libs/form/models';
import { AlertModel } from '@libs/common/models';
import { combineLatest, Subscription } from 'rxjs';
import { EmailItem, SubmitGroupItem } from './user-delete.model';

@Component({
  selector: 'ui-user-delete',
  templateUrl: './user-delete.component.html',
  styleUrls: ['./user-delete.component.scss'],
  imports: [
    AlertComponent,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    TextComponent,
    SubmitGroupComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDeleteComponent {
  private readonly ngForm: Signal<NgForm> = viewChild.required<NgForm>('form');
  private readonly resetFormSubscription: Subscription;

  public readonly hasPending: InputSignal<boolean | null | undefined> = input<boolean | null | undefined>();
  public readonly alertMessage: InputSignal<AlertModel | undefined> = input<AlertModel | undefined>();
  public readonly submitResult: OutputEmitterRef<string> = output<string>();
  public itemEmail: TextInputModel = EmailItem;
  public itemSubmit: SubmitGroupItemModel = SubmitGroupItem;
  public readonly emailControl: UntypedFormControl = new UntypedFormControl();

  public constructor() {
    this.resetFormSubscription = combineLatest([
      toObservable(this.hasPending),
      toObservable(this.alertMessage),
    ]).pipe(takeUntilDestroyed()).subscribe(() => {
      this.ngForm().resetForm();
    });
  }

  public onSubmit(): void {
    if (this.emailControl.valid) {
      this.submitResult.emit(String(this.emailControl.value));
    }
  }
}
